
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../api/apiClient';
import { setSubmitting, setError } from '../Slice//unifiedFormSlice';

interface SubmitIdentityPayload {
  identity_type: 'LEGAL' | 'PERSONAL';
  name: string;
  display_name: string;
}

export const submitIdentityForm = createAsyncThunk(
  'unifiedForm/submitIdentityForm',
  async (payload: SubmitIdentityPayload, { dispatch, rejectWithValue }) => {
    dispatch(setSubmitting(true));
    try {
      const formData = new URLSearchParams();
      formData.append('identity_type', payload.identity_type);
      formData.append('name', payload.name);
      formData.append('display_name', payload.display_name);

      const response = await apiClient.post('/v2/publisher/create', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

     return response.data; // کل پاسخ سرور را برمی‌گرداند
    } catch (error: any) {
      console.error('Thunk error:', error);

      // The api client interceptor already unwraps `error.response.data`, so
      // what arrives here is the server body itself: {message, errors}.
      // Reading `error.response.data` again always missed and fell through to
      // the generic network branch, hiding the real validation message.
      if (error?.errors || error?.message) {
        return rejectWithValue(error);
      }

      dispatch(setError('خطا در ارسال اطلاعات'));
      return rejectWithValue('خطا در ارسال اطلاعات');
    } finally {
      dispatch(setSubmitting(false));
    }
  }
);